export default __webpack_public_path__ + "static/media/CreatedUserImg.e69c4060.jpg";